import React from 'react';
import { ArrowRight, Package, Zap, Shield, Phone } from 'lucide-react';
import { stats } from '../data/mock';

const HeroSection = () => {
  const whatsappNumber = '50688937777';
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="sendhapy-hero">
      <div className="max-w-6xl mx-auto px-6 py-20 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left">
            <h1 
              className="text-5xl md:text-6xl font-bold mb-6 leading-tight"
              style={{ color: 'white' }}
            >
              Tu conexión directa entre{' '}
              <span style={{ color: 'var(--sendhapy-yellow)' }}>Miami</span>
              {' '}y Costa Rica
            </h1>
            
            <p 
              className="text-xl md:text-2xl mb-8 leading-relaxed"
              style={{ color: 'rgba(255, 255, 255, 0.9)' }}
            >
              Servicio de courier rápido, seguro y confiable. Rastrea tus paquetes en tiempo real y recibe con total tranquilidad.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 mb-12">
              <button
                onClick={() => scrollToSection('casillero')}
                className="btn-sendhapy-primary whitespace-nowrap"
                data-testid="hero-abrir-casillero-btn"
              >
                Abrir casillero
                <ArrowRight size={18} />
              </button>
              <button
                onClick={() => scrollToSection('tracking')}
                className="btn-sendhapy-secondary"
                data-testid="hero-tracking-btn"
              >
                Consultar Tracking
              </button>
              <a
                data-testid="hero-whatsapp-btn"
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-whatsapp"
              >
                <Phone size={18} />
                WhatsApp
              </a>
            </div>

            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="flex items-center gap-3 justify-center lg:justify-start">
                <Package size={24} style={{ color: 'var(--sendhapy-yellow)' }} />
                <span className="text-white font-medium">Courier Internacional</span>
              </div>
              <div className="flex items-center gap-3 justify-center lg:justify-start">
                <Zap size={24} style={{ color: 'var(--sendhapy-yellow)' }} />
                <span className="text-white font-medium">Entregas Rápidas</span>
              </div>
              <div className="flex items-center gap-3 justify-center lg:justify-start">
                <Shield size={24} style={{ color: 'var(--sendhapy-yellow)' }} />
                <span className="text-white font-medium">Seguridad Garantizada</span>
              </div>
            </div>

            {/* WhatsApp Contact */}
            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-white/80 mb-2">¿Preguntas? Contáctanos directamente:</p>
              <a 
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl font-bold hover:underline"
                style={{ color: 'var(--sendhapy-yellow)' }}
              >
                +506 8893-7777
              </a>
            </div>
          </div>

          {/* Right Content - Foto oficial de entrega */}
          <div>
            <figure className="rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10" data-testid="hero-foto-entrega">
              <img
                src="/images/sendhapy-entrega.jpg"
                alt="Repartidor de SendHapy entregando un paquete a una clienta, con la furgoneta SendHapy al fondo"
                className="w-full h-auto block"
                width="1536"
                height="1024"
                fetchpriority="high"
              />
            </figure>
            <div className="stats-grid mt-8 hidden lg:grid">
              {stats.map((stat, index) => (
                <div key={index} className="stat-card">
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
